import { SendHorizontal, Trash2 } from 'lucide-react'
import { clock, type VoiceRecording } from '@/lib/voiceMessage'
import styles from './VoiceRecorder.module.css'

/** Полоса над полем ввода, пока идёт запись. */
export function VoiceRecordBar({ rec, busy, onSend, onCancel }: { rec: VoiceRecording; busy: boolean; onSend: () => void; onCancel: () => void }) {
  const levels = rec.levels().slice(-56)
  return (
    <div className={styles.bar} role="status" aria-label="Идёт запись голосового">
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.time}>{clock(rec.elapsed())}</span>
      <span className={styles.wave} aria-hidden="true">
        {levels.map((l, i) => <span key={i} style={{ height: `${Math.max(10, Math.round(l * 100))}%` }} />)}
      </span>
      <button type="button" className={styles.cancel} data-tooltip="Отменить запись" aria-label="Отменить запись" disabled={busy} onClick={onCancel}>
        <Trash2 size={18} />
      </button>
      <button type="button" className={styles.send} data-tooltip="Отправить голосовое" aria-label="Отправить голосовое" disabled={busy} onClick={onSend}>
        <SendHorizontal size={18} />
      </button>
    </div>
  )
}
